import { http, downhttp } from "./http";

// 01. 发送短信验证码
export const getcode = (type, data) => {
    return http.post("/user/" + type + "_getcode/", data);
};

// 02 密码登录提交
export const _loginSubmit = (data) => {
    return http.post("/user/login/", data);
};

// 03 短信登录提交
export const _smsSubmit = (data) => {
    return http.post("/user/sms_submit/", data);
};

// 04 注册提交
export const _registerSubmit = (data) => {
    return http.post("/user/register_submit/", data);
};

//05 检验用户名是否存在
export const _checkNickname = (data) => {
    return http.post("/user/register_check_nickname/", data);
};

//06 打开页面时，立即验证access_token
export const _checkAccessToken = () => {
    return http.post("/user/check_access_token/", {});
};

//07 验证是否登录
export const _checkLogin = () => {
    return http.post("/user/check_login/", {});
};

//08 退出登录
export const _logout = (data) => {
    return http.post("/user/logout/", data);
};

// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 风机基础的接口
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～

// 01 基础参数确认，提交参数
export const _windBaseSubmit = (data) => {
    return http.post("/windbase/submit/", data);
};

// 02 基础下载接口
export const _windBaseDownload = (data) => {
    return downhttp.post("/windbase/download/", data);
};

// 03 扩展基础（完整）计算接口
export const _designCompletely = (data) => {
    return downhttp.post("/windbase/design/completely/", data);
};

// 04 扩展基础（快速）计算接口
export const _designQuickly = (data) => {
    return http.post("/windbase/design/quickly/", data);
};


// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 微信登录的接口(方法一：带参数二维码注册与登录的)
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～

// 01 获取微信登录的二维码
export const getQrcodeUrl = () => {
    return http.get("/wechat/qrcode_url/", {});
};

// 02 微信登录的轮询接口
export const _loginPoll = (data) => {
    return http.post("/wechat/verify_login/", data);
};

// 03 退出登录接口
export const wxlogout = (data) => {
    return http.post("/wechat/logout/", data);
};


// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 微信登录的接口(方法二：服务号的微信网页授权登录)
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～

// // 01 授权登录scene的接口
// export const _wxOauthScene = () => {
//     return http.get("/wechat/wxoauthscene/", {});
// };
// // 02 授权登录的接口
// export const _wxOauth = () => {
//     return http.get("/wechat/wxoauth/", {});
// };
export const _wxLogin = (data) => {
    return http.post("/wechat/wxlogin/", data);
};
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 意见反馈的接口
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
export const feedBack = (data) => {
    return http.post("/feedback/advice/", data, { headers: { 'Content-Type': 'multipart/form-data' } });
};




// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 工具箱的接口
// ～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～～
// 01 材料强度接口(一次性请求，类似精灵图)
export const _getStrength = () => {
    return http.get("/toolbox/strength/", {});
};
// 02 风荷载雪荷载接口
// 02-01获取地点列表（get请求）
export const _getWindSnowLocal = () => {
    return http.get("/toolbox/windsnow/", {});
};
// 02-02获取荷载值（post请求）
export const _getWindSnowValue = (data) => {
    return http.post("/toolbox/windsnow/", data);
};
// 03 地震动参数接口
// 03-01获取地点列表（get请求）
export const _getSeismicLocal = () => {
    return http.get("/toolbox/seismic/", {});
};
// 03-02获取参数值（post请求）
export const _getSeismicValue = (data) => {
    return http.post("/toolbox/seismic/", data);
};
